import { Event, EventsFetchRequest } from '@bimdata/definitions/dto';
import api from './api';
import { compressQuery } from '@bimdata/client/utils/compression';
import castDates from '@bimdata/client/utils/cast-dates';

async function fetch(params: EventsFetchRequest): Promise<Array<Event>> {
  const { data } = await api.get<Array<Event>>(`/events`, {
    params: { q: compressQuery(params) }
  });
  return data.reverse().map((e) => castDates<Event>(e, [ 'date' ]));
}

async function markAsDelivered(events: Array<string>): Promise<void> {
  await api.post(`/events/delivered`, { code: events });
}

export { fetch, markAsDelivered };